/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReportTable/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Done from './Done/index'
import Failed from './Failed/index'
import No from './No/index'
import Pending from './Pending/index'
import Processing from './Processing/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ReportTable({
  children,
  viewPath = "/DesignSystem/Report/ReportTable",
  onSelectionChanged,
  onToggleColumnsVisibility,
  rowGroupPanelShow,
  rowSelection,
  onIsRowSelected
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let reportLastExecutionStatusValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'last_execution.status',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: reportLastExecutionStatusValueData,
})
  return (<React.Fragment
>
<div
  data-testid="ReportTable.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Pending'}>
<Pending
  viewPath={`${viewPath}/Pending`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Done'}>
<Done
  viewPath={`${viewPath}/Done`}
 onSelectionChanged={onSelectionChanged}
 onToggleColumnsVisibility={onToggleColumnsVisibility}
 rowGroupPanelShow={rowGroupPanelShow}
 rowSelection={rowSelection}
 onIsRowSelected={onIsRowSelected}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Failed'}>
<Failed
  viewPath={`${viewPath}/Failed`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Processing'}>
<Processing
  viewPath={`${viewPath}/Processing`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}